import {atom} from 'jotai'

export const filterAtom = atom({'Npc': true, 'Location': true, 'Critter': true});